import { usePage } from "PFApp/use_page";
import { fetchPaginatedCollection } from "PFCore/helpers/collection";
import { ApiRoute } from "PFCore/utilities/routes";
import { SamlConfig } from "PFTypes/saml_config";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { getSamlToken } from "../services/saml_configs_api";

const initPage = { samlConfigs: [], token: "", loaded: false, errors: [] };

type SamlConfigPage = {
  loaded: boolean;
  samlConfigs: SamlConfig[];
  token: string;
  errors: string[];
};

export const useSamlConfigs = () => {
  const { t } = useTranslation();
  const { page, setPage, mergePage, resetPage } = usePage<SamlConfigPage>("saml_configs", initPage);

  const fetchSamlConfigs = (page = 1) => {
    const params = {
      page,
      perPage: 10,
      apiVersion: 1
    };

    fetchPaginatedCollection(ApiRoute("/api/admin/saml_configs"), params)
      .then((response) => {
        mergePage({
          samlConfigs: response
        });
      })
      .catch(() =>
        mergePage({
          errors: [t("thereWasAnError")]
        })
      );
  };

  const fetchSamlToken = () =>
    getSamlToken()
      .then((response) =>
        mergePage({
          token: response.saml_token
        })
      )
      .catch(() => {
        mergePage({
          errors: [t("thereWasAnError")]
        });
      });

  const initialFetch = () => {
    $.when(fetchSamlConfigs(), fetchSamlToken()).always(() => mergePage({ loaded: true }));
  };

  useEffect(() => {
    setPage(initPage);
    return resetPage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    initialFetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { ...page, fetchSamlConfigs, fetchSamlToken };
};
